import angular from 'angular';
import 'angular-loading-bar/build/loading-bar';
import appointmentFinderComponent from './appointment-finder.component';
import appointmentFinderService from './appointment-finder-graphql.service'

import AngularApollo from "angular1-apollo";
import {ApolloClient} from "apollo-client";
import {InMemoryCache} from "apollo-cache-inmemory";
import {HttpLink} from "apollo-link-http";

const appointmentFinder = angular
	.module('appointmentFinder', ['angular-loading-bar', AngularApollo])
	.service('appointmentFinderService',appointmentFinderService)
	.component('appointmentFinder', appointmentFinderComponent)
	.config(apolloProvider => {
		apolloProvider.defaultClient(new ApolloClient({
			link: new HttpLink({
				uri: "https://fr-healthcare-api.herokuapp.com/graphql"
			}),
			cache: new InMemoryCache()
		}));
	})
	.name;

export default appointmentFinder;


// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/components/appointment-finder/appointment-finder.modules.js